import styled from 'styled-components'

import { useAssetsUrlBuilder } from '@root/shared'

import type { ClassNameProps } from '@root/shared/react'

type TrendingEmojiIconProps = { size: number; emojiId: string } & ClassNameProps

export const TrendingEmojiIcon: React.FC<TrendingEmojiIconProps> = ({
  className,
  emojiId,
  size,
}) => {
  const { customEmojiWebmUrl } = useAssetsUrlBuilder()

  return (
    <Root
      className={className}
      width={size}
      height={size}
      src={customEmojiWebmUrl(emojiId)}
      playsInline
      muted
      autoPlay
      loop
    />
  )
}

const Root = styled.video``
